import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
export class MicroLineChart extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, color, data, inverse } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.XYChart);

    chart.data = data.map((item) => ({
      date: new Date(item.date),
      value: item.value
    }));

    const amColor = am4core.color(color);

    // chart.width = am4core.percent(45);
    // chart.height = 70;
    // chart.padding(20, 5, 2, 5);
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.lineY.disabled = true;
    chart.cursor.behavior = 'none';
    // chart.titles.template.fontSize = 10;
    // chart.titles.template.textAlign = 'left';
    // chart.titles.template.isMeasured = false;
    // chart.titles.create().text = title;

    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.disabled = true;
    dateAxis.renderer.labels.template.disabled = true;
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0.7;
    dateAxis.cursorTooltipEnabled = false;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.renderer.inversed = inverse ?? false;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.cursorTooltipEnabled = false;

    const series = chart.series.push(new am4charts.LineSeries());
    series.tooltipText = '{date}: [bold]{value}';
    series.dataFields.dateX = 'date';
    series.dataFields.valueY = 'value';
    series.tensionX = 0.8;
    series.strokeWidth = 2;
    series.stroke = amColor;

    // render data points as bullets
    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.opacity = 0;
    bullet.circle.fill = amColor;
    bullet.circle.propertyFields.opacity = 'opacity';
    bullet.circle.radius = 3;

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} />;
  }
}

// static propTypes = {
//   chartId: PropTypes.string.isRequired,
//   color: PropTypes.string.isRequired,
//   data: PropTypes.arrayOf(
//     shape({
//       date: PropTypes.string.isRequired,
//       value: PropTypes.number.isRequired
//     }).isRequired
//   ).isRequired,
//   inverse: PropTypes.bool
// };
